'use strict';

//React/Components
import React from 'react';
import RadioInput from '../Common/RadioInput.jsx';

//Constants
import ApplicationConstants from '../../constants/ApplicationConstants';
import YourDetailsConstants from '../../constants/YourDetailsConstants';
const YesNoData = ApplicationConstants.YesNoValues;
const YesNoRadioData = [{ id: YesNoData.YES , name: YesNoData.YES_LONG, isHidden: false }, { id: YesNoData.NO, name: YesNoData.NO_LONG, isHidden: false }];

//Action
import YourDetailsActions from '../../actions/YourDetailsActions';

export default class AustralianTaxResident extends React.Component {
    constructor(props) {
        super(props);
    }
    updateAustralianTaxResidentData(index, event) {
        YourDetailsActions.updateYourDetailsData(event.target.model, event.target.id, event.target.value, index);
    }

    render() {        
        let modelName = 'isAustralianTaxResident';
        let value = this.props.data[modelName];
        
        return (<RadioInput id={this.props.section + modelName + this.props.index}
                data={YesNoRadioData}
                value={value}
                onChange={this.updateAustralianTaxResidentData.bind(this, this.props.index)}
                model={modelName}
                label={YourDetailsConstants.Labels.isAustralianTaxResident.displayLabel} 
                errorList={this.props.errorList}/>
        );
    }
}
AustralianTaxResident.propTypes = {
    index: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
    data: React.PropTypes.object.isRequired,    
    section: React.PropTypes.string,
    errorList: React.PropTypes.array
}
AustralianTaxResident.defaultProps = {
    index: '',
    section: '',
    errorList: []
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/AustralianTaxResident.jsx